import React from "react";
import styled from "styled-components";
import { breakpoints } from './constants';

import bg from '../img/rhei-logo.svg';

const BBTVLogo = styled.a`
  background: ${props => 'url(' + bg + ')'} center top no-repeat;
  padding: 50px 0 0 0;
  text-align: center;
  position: absolute;
  bottom: 190px;
  left: 50%;
  transform: translate(-50%, 0);
  @media (min-width: ${breakpoints.desktop}) {
    bottom: 60px;
  }
`;

export default BBTVLogo;



// WEBPACK FOOTER //
// ./src/styled-components/BBTVLogo.js